export default "__VITE_ASSET__CpPNArLQ__"